import { IconSvg, IconSvgProps } from "./icon"

// Bar thickness, and the diameter of each rounded end. A bar's drawn length is
// its span plus one of these, so a bar of exactly this length is a circle.
const CAP = 1.5

// The six bars: x, then the y range each is drawn over. All centred on 12, the
// viewBox middle, so a bar collapsed to a dot still sits on the axis.
const BARS = [
  [4, 10.5, 13.5],
  [7.2, 6.5, 17.5],
  [10.4, 3, 21],
  [13.6, 8.5, 15.5],
  [16.8, 5.5, 18.5],
  [20, 10.5, 13.5],
] as const

// One rounded rect per bar rather than a path of round-capped lines: an `rx`
// corner stays circular at any height, where a scaled cap squashes into a slab
// instead of collapsing to a dot.
export default function AudioLines({
  strokeWidth = CAP,
  strokeModifier = 1,
  ...props
}: IconSvgProps) {
  // Nothing here is stroked; the stroke props are consumed as bar thickness.
  const cap = strokeWidth * strokeModifier
  return (
    <IconSvg {...props}>
      {BARS.map(([x, y1, y2]) => {
        const height = y2 - y1 + cap
        return (
          <rect
            key={x}
            x={x - cap / 2}
            y={(y1 + y2) / 2 - height / 2}
            width={cap}
            height={height}
            rx={cap / 2}
            fill="currentColor"
            stroke="none"
          />
        )
      })}
    </IconSvg>
  )
}
